import { render, staticRenderFns } from "./SubidaDocumentos.vue?vue&type=template&id=bf78d312"
import script from "./SubidaDocumentos.vue?vue&type=script&lang=js"
export * from "./SubidaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./SubidaDocumentos.vue?vue&type=style&index=0&id=bf78d312&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports